import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

/**
 * Generic masters fetcher used by Financiers and Evaluators dropdowns.
 * Returns the live list + a reload(). `activeOnly` defaults to true since
 * the sale form only ever needs active entries.
 */
export default function useMaster(endpoint, { activeOnly = true } = {}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(endpoint, {
        params: activeOnly ? { active_only: true } : {},
      });
      setItems(data || []);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [endpoint, activeOnly]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { items, loading, reload };
}
